// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 6132 ? "06f6b0c0" : chunkId) + "." + {"984":"7b61a541f5e6be11","2741":"653c787f2490dc24","6132":"6570652ab2180df4","8850":"3eef9429d58691ea","9651":"bddd959a7c85efc2"}[chunkId] + ".js";
};